/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconTwitter = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <path
        fill="currentColor"
        d="M23.32 6.44a.5.5 0 0 0-.2-.87l-.79-.2a.5.5 0 0 1-.33-.7l.44-.89a.501.501 0 0 0-.58-.7l-2 .56a.502.502 0 0 1-.44-.08 5 5 0 0 0-8 4v.36a.25.25 0 0 1-.22.25c-2.81.33-5.5-1.1-8.4-4.44a.508.508 0 0 0-.51-.15A.5.5 0 0 0 2 4a7.575 7.575 0 0 0 .46 4.92.25.25 0 0 1-.26.36l-1.12-.22a.5.5 0 0 0-.57.59 5.15 5.15 0 0 0 2.37 3.78.25.25 0 0 1 0 .45l-.53.21a.5.5 0 0 0-.26.69 4.36 4.36 0 0 0 3.2 2.48.25.25 0 0 1 0 .47c-1.36.562-2.819.845-4.29.83a.51.51 0 0 0-.2 1 20.063 20.063 0 0 0 8.14 1.93 12.58 12.58 0 0 0 7-2A12.5 12.5 0 0 0 21.5 9.06v-.87a.499.499 0 0 1 .18-.38l1.64-1.37z"
      />
    </svg>
  ),
);
